import { Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import useSettingsParams from "hooks/useSettingsParams";
import { useObject } from "./context/ObjectProvider";
import ObjectsFilter from "./ObjectsToolBar/ObjectsFilter";
import ListToolBarActions from "components/toolbar/ListToolBarActions";
import { useAuth } from "context/AuthContext";
import { canViewSales, hasUserAccess, isSellerUser } from "utils/helpers/access/hasUserAccess";
import { useNeedPay } from 'modules/admin';
import SolarIcon from 'components/icons/SolarIcon';

const ObjectsToolBar = ({ setNewObject, setNewSale }) => {
    const { t } = useTranslation(['Objects']);
    const params = useSettingsParams();
    const { auth } = useAuth();
    const { needPay } = useNeedPay();
    const {
        onlySale,
        onlyService,
        isSaleLike,
        triggerListReset,
        triggerListRefresh,
        showDebtor,
        showClient,
        showTeam,
        showCreated,
        showAccess,
        showInWork,
        toggleListColumn,
    } = useObject();
    const canCreateObject = hasUserAccess(auth?.user, 'objectCreate') || isSellerUser(auth?.user);
    const canCreateSale = canViewSales(auth?.user);
    const columnItems = [
        { id: 'client', label: t('listColumns.client'), visible: showClient },
    ];
    if (!isSaleLike) {
        columnItems.push({ id: 'team', label: t('listColumns.team'), visible: showTeam });
    }
    columnItems.push({ id: 'created', label: t('listColumns.created'), visible: showCreated });
    columnItems.push({ id: 'access', label: t('listColumns.access'), visible: showAccess });
    columnItems.push({ id: 'inWork', label: t('listColumns.inWork'), visible: showInWork });
    if (params.objectPaymentControl) {
        columnItems.push({ id: 'payments', label: t('listColumns.payments'), visible: showDebtor });
    }

    return (
        <div className="mb-3" style={{minWidth:'100px'}}>
            <div className="page-toolbar-actions">

            {onlySale && canCreateSale && (
                <Button
                    className="fs-14"
                    size="sm"
                    variant="success"
                    onClick={(e) => {
                        e.currentTarget.blur();
                        if (needPay()) return;
                        setNewSale({});
                    }}
                >
                    <SolarIcon name="plus" className="fs-14 p-0" />
                    <span className="ms-1">{t('toolAddSale')}</span>
                </Button>
            )}

            {onlyService && canCreateSale && (
                <Button
                    className="fs-14"
                    size="sm"
                    variant="success"
                    onClick={(e) => {
                        e.currentTarget.blur();
                        if (needPay()) return;
                        setNewSale({ onlyService: true });
                    }}
                >
                    <SolarIcon name="plus" className="fs-14 p-0" />
                    <span className="ms-1">{t('toolAddServiceSale')}</span>
                </Button>
            )}

            {!isSaleLike && canCreateObject && (
                <Button
                    className="fs-14"
                    size="sm"
                    variant="success"
                    onClick={(e) => {
                        e.currentTarget.blur();
                        if (needPay()) return;
                        setNewObject({});
                    }}
                >
                    <SolarIcon name="plus" className="fs-14 p-0" />
                    <span className="ms-1">{t('toolAddObject')}</span>
                </Button>
            )}

            <ListToolBarActions
                onReset={triggerListReset}
                onRefresh={triggerListRefresh}
                columns={{ items: columnItems, onToggle: toggleListColumn }}
            />

            <ObjectsFilter />

        </div>
    </div>

    )
}

export default ObjectsToolBar;
